// Copyright (c) 2017 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import LaborRates, {getDefaultState as getLaborRatesDefaultState} from './labor-rates';
import SearchFilters from '../../../shared/state/search-filters';
import {getDefaultState as getSearchFiltersDefaultState} from './search-filters';
import t from 'tcomb';

const State = t.struct({
    busyCounter: BusyCounter,
    dealers: LaborRates,
    dealersFiltered: LaborRates,
    searchFilters: SearchFilters,
    selectedDealers: LaborRates
}, 'State');

export const getDefaultState = () =>
    new State({
        busyCounter: getBusyCounterDefaultState(),
        dealers: getLaborRatesDefaultState(),
        dealersFiltered: getLaborRatesDefaultState(),
        searchFilters: getSearchFiltersDefaultState(),
        selectedDealers: getLaborRatesDefaultState()
    });

export default State;



// WEBPACK FOOTER //
// ./src/claim/labor-rate-dealers/state/index.js